var _defs, _path, _path2, _ellipse, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2Flap01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-4,.cls-3{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-4{stroke-width:3px;}.cls-3{stroke-dasharray:3.01;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357,218.13V280.4c0,23.77-20.67,43.05-46.16,43.05H119.16C93.67,323.45,73,304.17,73,280.4V218.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.87,220.8V281c0,21.37-19.3,38.75-43,38.75H119.16c-23.71,0-43-17.38-43-38.75V220.8Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.33,
    cy: 290.9,
    rx: 16.66,
    ry: 16.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 213.61,
    y: 268.97,
    width: 3.44,
    height: 44.93
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Flap01);
export default __webpack_public_path__ + "static/media/2 FLAP-01.eca726efde2ce61679b2827a104e77db.svg";
export { ForwardRef as ReactComponent };